/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MappableEntity } from './MappableEntity';
import {
    MappableEntityFromJSON,
    MappableEntityFromJSONTyped,
    MappableEntityToJSON,
} from './MappableEntity';

/**
 * 
 * @export
 * @interface DescribeMappableEntityResponse
 */
export interface DescribeMappableEntityResponse {
    /**
     * 
     * @type {MappableEntity}
     * @memberof DescribeMappableEntityResponse
     */
    entity: MappableEntity;
}

/**
 * Check if a given object implements the DescribeMappableEntityResponse interface.
 */
export function instanceOfDescribeMappableEntityResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "entity" in value;

    return isInstance;
}

export function DescribeMappableEntityResponseFromJSON(json: any): DescribeMappableEntityResponse {
    return DescribeMappableEntityResponseFromJSONTyped(json, false);
}

export function DescribeMappableEntityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DescribeMappableEntityResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity': MappableEntityFromJSON(json['entity']),
    };
}

export function DescribeMappableEntityResponseToJSON(value?: DescribeMappableEntityResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity': MappableEntityToJSON(value.entity),
    };
}

